import React from 'react';
import { CalendarRangeIcon, UserCheckIcon, UsersIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { ctaMicrocopy, dre } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const icons: LucideIcon[] = [CalendarRangeIcon, UserCheckIcon, UsersIcon];
const tiles = ['bg-sun text-ink', 'bg-coral text-white', 'bg-violet text-white'];

/** New in this landing: the DRE / coordinator who buys one plan for the whole catechist team */
export function DreSection() {
  return <section id="dre" aria-labelledby="dre-title" className="scroll-mt-4 bg-violet-soft py-12 md:py-16" data-id="element-61" data-mp="1fifqpaogf73f">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-62" data-mp="15q9vzt6tibkj">
        <SectionHeading id="dre-title" eyebrow={dre.eyebrow} title={dre.title} sub={dre.sub} data-id="element-63" data-mp="15pqq5aufzdmv" />

        <ul className="mx-auto mt-8 grid max-w-[980px] gap-3 md:mt-10 md:grid-cols-3 md:gap-4" data-id="element-64" data-mp="2378nf9cwhiz3">
          {dre.points.map((p, i) => {
          const Icon = icons[i % icons.length];
          return <li key={p.title} className="rounded-xl border border-violet/15 bg-white p-5 md:p-6" data-id="element-65" data-mp="8ctiift9590a" data-mpi={i}>
                <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${tiles[i % tiles.length]}`} data-id="element-66" data-mp="cctvrx4m7e5r">
                  <Icon className="h-5 w-5" strokeWidth={2.25} aria-hidden="true" data-id="element-67" data-mp="3ups0sig9kx6s" />
                </span>
                <h3 className="mt-4 font-display text-[17px] font-extrabold leading-snug text-brand" data-id="element-68" data-mp="3ktexcsux34yu">{p.title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-ink/75" data-id="element-69" data-mp="3ps9smua2mlzu">{p.text}</p>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-5 max-w-[640px] text-center text-[13px] leading-relaxed text-ink/60" data-id="element-70" data-mp="3bubd3lk0kjir">{dre.note}</p>

        <div className="mx-auto mt-8 flex max-w-[460px] justify-center" data-id="element-71" data-mp="3gtxqbuzudzrk">
          <CtaButton microcopy={ctaMicrocopy} align="center" data-id="element-72" data-mp="1a2oua7a9zuxd" />
        </div>
      </div>
    </section>;
}